import { T } from '../../i18n/components/T.js'

export const FallbackLoading = () => {
  return (
    <div>
      <T id="Generics.LoadingDotDotDot" defaultMessage="Loading..." />
    </div>
  )
}
